exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.VueSplitter-Pane-item {\n  margin: 0;\n  padding: 0;\n  border: none;\n  overflow: hidden;\n}\n.VueSplitter-Pane-left, .VueSplitter-Pane-top {\n  flex: inherit;\n}\n.VueSplitter-Pane-right, .VueSplitter-Pane-bottom {\n  flex: 1;\n}\n", ""]);

// exports
exports.locals = {
	"item": "VueSplitter-Pane-item",
	"left": "VueSplitter-Pane-left",
	"top": "VueSplitter-Pane-top",
	"right": "VueSplitter-Pane-right",
	"bottom": "VueSplitter-Pane-bottom"
};